import { Client } from 'urql';
import { accountQuery } from './accountQuery';

export const fetchAccount = async ({ client }: { client: Client }) => {
  const { data, error } = await client.query(accountQuery, {}).toPromise();
  return { data, error };
};
